import { render } from "./DynamicAddModal.vue?vue&type=template&id=a4b0a240&scoped=true"
import script from "./DynamicAddModal.vue?vue&type=script&lang=js"
export * from "./DynamicAddModal.vue?vue&type=script&lang=js"

import "./DynamicAddModal.vue?vue&type=style&index=0&id=a4b0a240&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b0a240"]])

export default __exports__